/*
 * Spec PDP — gallery, variant pills, tabs, fitment banner.
 * Vanilla JS. Variant data is embedded as JSON; money strings are pre-formatted
 * server-side so no client-side currency formatting is needed.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.spInit === 'true') return;
    root.dataset.spInit = 'true';

    /* ---------- Gallery ---------- */
    var mainImg = root.querySelector('[data-sp-main]');
    root.querySelectorAll('[data-sp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) {
          mainImg.src = src;
          if (thumb.querySelector('img')) mainImg.alt = thumb.querySelector('img').alt;
        }
        root.querySelectorAll('[data-sp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---------- Variants ---------- */
    var dataEl = root.querySelector('[data-sp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) {}
    var form = root.querySelector('[data-sp-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var selected = [];

    root.querySelectorAll('[data-sp-option]').forEach(function (group, i) {
      var initial = group.querySelector('[data-sp-value].is-active') || group.querySelector('[data-sp-value]');
      selected[i] = initial ? initial.getAttribute('data-value') : null;
    });

    function findVariant() {
      // Single / default-variant products render no option pills, so `selected`
      // is empty — fall back to the only variant instead of matching nothing.
      if (!selected.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function setText(sel, val) {
      var el = root.querySelector(sel);
      if (el) el.textContent = val;
    }

    function updateVariant() {
      var v = findVariant();
      var priceEl = root.querySelector('[data-sp-price]');
      var compareEl = root.querySelector('[data-sp-compare]');
      var saveEl = root.querySelector('[data-sp-save]');
      var addBtn = root.querySelector('[data-sp-add]');
      var stockEl = root.querySelector('[data-sp-stock]');
      var skuEl = root.querySelector('[data-sp-sku]');

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('[data-sp-add-label]').textContent = 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_money;
      if (compareEl) { compareEl.textContent = v.compare_money || ''; compareEl.hidden = !v.compare_money; }
      if (saveEl) { saveEl.textContent = v.save_money ? ('Poupe ' + v.save_money) : ''; saveEl.hidden = !v.save_money; }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (stockEl) {
        stockEl.classList.toggle('is-out', !v.available);
        setText('[data-sp-stock-text]', v.available ? (root.dataset.instock || 'Em stock') : (root.dataset.outstock || 'Esgotado'));
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('[data-sp-add-label]').textContent = v.available ? (root.dataset.addlabel || 'Adicionar ao carrinho') : (root.dataset.soldlabel || 'Esgotado');
      }
      // reflect variant in URL for sharing / refresh
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-sp-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-sp-option]');
        var idx = parseInt(group.getAttribute('data-sp-option'), 10);
        group.querySelectorAll('[data-sp-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[idx] = btn.getAttribute('data-value');
        updateVariant();
      });
    });

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-sp-qty]');
    root.querySelectorAll('[data-sp-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        val += (b.getAttribute('data-sp-qty-btn') === 'plus') ? 1 : -1;
        qtyInput.value = Math.max(1, val);
      });
    });

    /* ---------- Buy Now (add + go to checkout) ---------- */
    var buyNow = root.querySelector('[data-sp-buynow]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var v = findVariant();
        if (!v || !v.available) return;
        buyNow.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: parseInt((qtyInput && qtyInput.value) || 1, 10) })
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyNow.disabled = false; });
      });
    }

    /* ---------- Tabs ---------- */
    var tabBtns = root.querySelectorAll('[data-sp-tab]');
    var panels = root.querySelectorAll('[data-sp-panel]');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-sp-tab');
        tabBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-sp-panel') !== key; });
      });
    });

    /* ---------- Fitment banner ---------- */
    var banner = root.querySelector('[data-sp-fitment]');
    if (banner) {
      var fits = (banner.getAttribute('data-fits') || '').split(',').filter(Boolean);
      function renderFit(v) {
        var label = banner.querySelector('[data-sp-fit-label]');
        var change = banner.querySelector('[data-sp-fit-change]');
        banner.classList.remove('is-fit', 'is-nofit', 'is-none');
        var keys = v && v.keys && v.keys.length ? v.keys : (v && v.slug ? [v.slug] : []);
        if (!v || !keys.length) {
          banner.classList.add('is-none');
          if (label) label.textContent = banner.dataset.noneText || 'Selecione o seu veículo para verificar a compatibilidade';
          if (change) change.textContent = banner.dataset.selectText || 'Selecionar';
          return;
        }
        var name = [v.make, v.model, v.year].filter(Boolean).join(' ');
        if (keys.some(function (k) { return fits.indexOf(k) !== -1; })) {
          banner.classList.add('is-fit');
          if (label) label.textContent = (banner.dataset.fitText || 'Compatibilidade confirmada —') + ' ' + name;
        } else {
          banner.classList.add('is-nofit');
          if (label) label.textContent = (banner.dataset.nofitText || 'Não confirmada para o seu') + ' ' + name;
        }
        if (change) change.textContent = banner.dataset.changeText || 'Mudar de veículo';
      }
      if (window.VehicleGarage) window.VehicleGarage.subscribe(renderFit);
      else document.addEventListener('vehicle:change', function (e) { renderFit(e.detail); });

      var changeBtn = banner.querySelector('[data-sp-fit-change]');
      if (changeBtn) changeBtn.addEventListener('click', function () {
        var anchor = document.getElementById('vehicle-finder-anchor');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth' });
        else window.location.href = '/';
      });
    }

    updateVariant();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-spec-product]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
